import React from 'react'

const DownArrow = props => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      fill='none'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}
    >
      <circle cx='12' cy='12' r='10' />
      <path d='M12 8v8' />
      <path d='m8 12 4 4 4-4' />
    </svg>
  )
}

export default DownArrow
